import { createFileRoute, redirect } from "@tanstack/react-router";
import { cn } from "cn";
import * as z from "zod";
import ResponsiveWrapper from "@/components/ui/layout/box/responsive-wrapper";
import PublicLayout from "@/components/ui/layout/public-layout";
import { AuthRedirectProvider } from "@/features/auth/_providers/auth-redirect-provider";
import { ActivateForm } from "@/features/auth/activate/_components/activate-form";

export const Route = createFileRoute("/(auth)/activate")({
  validateSearch: z.object({
    email: z.string().optional(),
  }),
  beforeLoad: ({ search }) => {
    if (!search.email) {
      throw redirect({ to: "/sign-in" });
    }
  },
  component: ActivatePage,
});

function ActivatePage() {
  return (
    <AuthRedirectProvider>
      <PublicLayout>
        <ResponsiveWrapper
          className={cn(
            /* sorted */
            "grow",
            "py-12",
            "sm:mx-auto sm:w-full sm:max-w-[25.5rem]",
          )}
        >
          <ActivateForm />
        </ResponsiveWrapper>
      </PublicLayout>
    </AuthRedirectProvider>
  );
}
